export enum Permission {
  // 库存管理
  STOCK_READ = 'stock:read',
  STOCK_WRITE = 'stock:write',

  // 订单管理
  ORDER_READ = 'order:read',
  ORDER_WRITE = 'order:write',

  // 商品管理
  PRODUCT_READ = 'product:read',
  PRODUCT_WRITE = 'product:write',

  // 加工坊管理
  WORKSHOP_READ = 'workshop:read',
  WORKSHOP_WRITE = 'workshop:write',

  // 用户管理
  USER_MANAGE = 'user:manage',

  // 内容运营
  CONTENT_READ = 'content:read',
  CONTENT_WRITE = 'content:write',

  // 财务
  FINANCE_READ = 'finance:read',
  FINANCE_WRITE = 'finance:write',

  // 系统设置
  SETTING_READ = 'setting:read',
  SETTING_WRITE = 'setting:write',
}
